import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { SORT_OPTIONS } from '@/utils/filters';

export const SortSelect = ({ value, onChange }) => (
  <Select value={value} onValueChange={onChange}>
    <SelectTrigger className="w-44 rounded-xl" data-testid="sort-select">
      <SelectValue placeholder="Sort" />
    </SelectTrigger>
    <SelectContent>
      {SORT_OPTIONS.map((o) => (
        <SelectItem key={o.value} value={o.value} data-testid={`sort-option-${o.value}`}>{o.label}</SelectItem>
      ))}
    </SelectContent>
  </Select>
);
